// material-ui
import {} from '@mui/material'
import React from 'react'

// assets
import * as autoThunks from 'features/auto-thunks'
import { useEffect } from 'react'

import MetricConfigurationComponent from 'components/MetricConfigurationComponent'
import { getUserClaims } from 'features/application/application-slice'
import {
  get_all_metricConfiguration,
  get_selected_metricConfiguration,
  setSelectedmetricConfiguration,
} from 'features/metricConfiguration/metricConfiguration-slice'
import { get_all_metricCursor } from 'features/metricCursor/metricCursor-slice'
import {
  get_all_metricDeployment,
  get_selected_metricDeployment,
  setSelectedmetricDeployment,
} from 'features/metricDeployment/metricDeployment-slice'
import { useDispatch, useSelector } from 'react-redux'

// ================================|| UI LIST - SIMPLE LIST ||================================ //

export default function SimpleList() {
  // Generate Grid
  let dispatch = useDispatch()
  let claims = useSelector(getUserClaims)
  let metricConfiguration_list = useSelector(get_all_metricConfiguration)
  let metricConfiguration = useSelector(get_selected_metricConfiguration)
  let metricDeployment_list = useSelector(get_all_metricDeployment)
  let metricDeployment = useSelector(get_selected_metricDeployment)
  let metricCursor_list = useSelector(get_all_metricCursor)
  const [metricConfigurationObj, setMetricConfigurationObj] =
    React.useState(null)
  const [deletedArg, setDeletedArg] = React.useState(null)
  const [deploymentArgs, setDeploymentArgs] = React.useState(null)
  const [enable_deployment, setEnable_deployment] = React.useState(null)
  const [isEnabledArg, setIsEnabledArg] = React.useState(null)
  const [runJobArgs, setRunJobArgs] = React.useState(null)
  const [resetArgs, setResetArgs] = React.useState(null)
  const [deploymentMetricArgs, setDeploymentMetricArgs] = React.useState(null)

  useEffect(() => {
    if (claims?.player) {
      dispatch(
        autoThunks.get_metric_configurations({ playerId: claims?.player }),
      )
    }
  }, [claims?.player])
  useEffect(() => {
    if (claims?.player && metricConfigurationObj) {
      dispatch(
        autoThunks.store_metric_configurations({
          playerId: claims?.player,
          metricConfiguration: (() => {
            function getmetricConfigurationObj(): any {
              return metricConfigurationObj
            }
            return getmetricConfigurationObj()
          })(),
        }),
      )
    }
  }, [claims?.player, metricConfigurationObj])
  useEffect(() => {
    if (claims?.player && deletedArg) {
      dispatch(
        autoThunks.delete_metric_configurations({
          playerId: claims?.player,
          id: (() => {
            function getConfigToDelete(): any {
              return deletedArg
            }
            return getConfigToDelete()
          })(),
        }),
      )
    }
  }, [claims?.player, deletedArg])
  useEffect(() => {
    if (claims?.player) {
      dispatch(autoThunks.get_metric_deployments({ playerId: claims?.player }))
    }
  }, [claims?.player])
  useEffect(() => {
    if (claims?.player && deploymentArgs) {
      dispatch(
        autoThunks.save_metric_deployment({
          playerId: claims?.player,
          deploymentArgs: (() => {
            function getDeploymentArgs(): any {
              return deploymentArgs
            }
            return getDeploymentArgs()
          })(),
        }),
      )
    }
  }, [claims?.player, deploymentArgs?.config])
  useEffect(() => {
    if (claims?.player && metricDeployment?.id && false) {
      dispatch(
        autoThunks.enable_metric_deployment({
          playerId: claims?.player,
          deploymentId: (() => {
            function getDeploymentArgs(): any {
              return metricDeployment?.id
            }
            return getDeploymentArgs()
          })(),
          enabled: (() => {
            function getEnabled(): any {
              return isEnabledArg
            }
            return getEnabled()
          })(),
        }),
      )
    }
  }, [claims?.player, isEnabledArg])
  useEffect(() => {
    if (claims?.player && runJobArgs) {
      dispatch(autoThunks.run_metric_jobs({ playerId: claims?.player }))
    }
  }, [claims?.player, runJobArgs])
  useEffect(() => {
    if (claims?.player && resetArgs) {
      dispatch(autoThunks.reset_cursors({ playerId: claims?.player }))
    }
  }, [claims?.player, resetArgs])
  useEffect(() => {
    if (claims?.player && deploymentMetricArgs) {
      dispatch(
        autoThunks.delete_metric_deployment({
          playerId: claims?.player,
          deploymentMetricId: (() => {
            function getdeploymentMetricArgs(): any {
              return deploymentMetricArgs
            }
            return getdeploymentMetricArgs()
          })(),
        }),
      )
    }
  }, [claims?.player, deploymentMetricArgs])
  useEffect(() => {
    if (claims?.player && metricDeployment?.deleted) {
      function deselectMetricDeployment(success: any): any {
        dispatch(setSelectedmetricDeployment(null))
      }
      deselectMetricDeployment({ success: undefined, res: undefined })
    }
  }, [claims?.player, metricDeployment])
  useEffect(() => {
    if (claims?.player) {
      dispatch(autoThunks.get_metric_cursors({ playerId: claims?.player }))
    }
  }, [claims?.player])

  function main(comp: any): any {
    return (
      <>
        <MetricConfigurationComponent
          metricConfiguration={metricConfiguration}
          cursors={metricCursor_list}
          metricConfigurations={metricConfiguration_list}
          onUnselectConfiguration={() => {
            dispatch(setSelectedmetricConfiguration(null))
          }}
          onSelect={(id: string) => {
            dispatch(setSelectedmetricConfiguration(id))
            if (metricDeployment?.metricConfigurationId !== id) {
              dispatch(setSelectedmetricDeployment(null))
            }
          }}
          menuItem={[
            {
              name: 'Run Metrics',
              handler: () => {
                setRunJobArgs(Date.now())
              },
            },
          ]}
          onToggleMetricDeployment={() => {
            // if(metricDeployment?.id === id) {
            //     setIsEnabledArg(!metricDeployment?.enabled)
            // }
            dispatch(
              autoThunks.enable_metric_deployment({
                playerId: claims.player,
                deploymentId: metricDeployment?.id,
                enabled: !metricDeployment?.enabled,
              }),
            )
          }}
          onDeploymentSelect={(id: string) => {
            dispatch(setSelectedmetricDeployment(id))
          }}
          onDeleteDeployment={(id: string) => {
            setDeploymentMetricArgs(id)
          }}
          onDelete={(id: string) => {
            setDeletedArg(id)
          }}
          onResetCursors={() => {
            setResetArgs(Date.now())
          }}
          metricDeployment={metricDeployment}
          metricDeployments={metricDeployment_list}
          onSaveDeployment={(config: any) => {
            if (metricDeployment) {
              setDeploymentArgs({
                ...metricDeployment,
                config,
              })
            } else if (metricConfiguration?.id) {
              setDeploymentArgs({
                name: metricConfiguration?.name,
                metricConfigurationId: metricConfiguration?.id,
                config,
              })
            }
          }}
          onSaveMetricConfiguration={(config: any) => {
            setMetricConfigurationObj(config)
          }}
        />
      </>
    )
  }

  let output_main = main(null)

  return output_main
}
